// index.js or main file
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Login from './pages/login/login';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import UserRules from './pages/rules/rules';
import Welcome from './pages/desi/welcome';
import PlayGame from './pages/desi/PlayGame';
import ThankYou from './pages/desi/thankyou';
import USER from './pages/dddUI/user';

// Benign Chrome warning when modals/route changes trigger ResizeObserver in the same frame.
const RESIZE_OBSERVER_LOOP = /ResizeObserver loop/;
window.addEventListener(
  'error',
  (event) => {
    if (RESIZE_OBSERVER_LOOP.test(event.message ?? '')) {
      event.stopImmediatePropagation();
    }
  },
  true
);

function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    document.body.classList.add("common-bg");
  }, [location]);
}

function App() {
  usePageBackground();

  return (
    <Provider store={store}>
      <Routes>
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/rules" element={<UserRules />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/play/:gameKey" element={<PlayGame />} />
              <Route path="/thankyou" element={<ThankYou />} />
              {/* Old routes: history entries land on their replacements. */}
              <Route path="/intro" element={<Navigate to="/rules" replace />} />
              <Route path="/home" element={<Navigate to="/welcome" replace />} />
              <Route path="/game" element={<Navigate to="/welcome" replace />} />
              <Route path="/complete" element={<Navigate to="/thankyou" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
